import axios from "axios";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { CiClock2 } from "react-icons/ci";
import { LuPhone } from "react-icons/lu";
import { MdOutgoingMail } from "react-icons/md";
import { PiBuildingOfficeDuotone } from "react-icons/pi";
import HeadingTexts from "./../../common/HeadingTexts";

const ContactGetInTouch = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    gender: "",
    DOB: "",
    speciality: "",
    query: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (message) setMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/inquiries/send-inquiry`,
        formData
      ); // Updated endpoint to match router
      if (response.status === 201) {
        toast.success("Enquiry submitted successfully!");
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          gender: "",
          DOB: "",
          speciality: "",
          query: "",
        });
        setMessage("Thank you! We'll get back to you soon.");
      }
    } catch (error) {
      console.error("Error submitting enquiry:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="md:px-10 px-6 md:pb-20 pt-4">
      <div className=" flex flex-col-reverse xl:flex-row md:gap-20 gap-6 xl:items-end w-full justify-between">
        <div className="xl:w-[50%] flex flex-col gap-y-8 md:p-8 sm:p-4 md:py-0 py-4">
          <article className="flex flex-col gap-y-3">
            <h6
              data-aos="fade-up"
              data-aos-duration="700"
              className="text-[#0BB6D9] font-semibold"
            >
              CONTACT US
            </h6>
            <h1
              data-aos="fade-up"
              data-aos-duration="700"
              className="text-4xl font-bold"
            >
              Feel Free To Contact Us
            </h1>
            <p
              data-aos="fade-up"
              data-aos-duration="700"
              className="text-[#4f4f4f]"
            >
              Nec tristiqu sed rutrum fringilla. it egestas fringilla
              condimentum purus.
            </p>
          </article>
          <div
            data-aos="fade-up"
            data-aos-duration="700"
            className="flex flex-col gap-y-5"
          >
            <h4 className="font-bold text-lg">Info Contact</h4>
            <div
              data-aos="fade-up"
              data-aos-duration="700"
              className="flex gap-5 items-center"
            >
              <span className="text-[#0BB6D9] text-3xl">
                <LuPhone />
              </span>
              <article className="flex flex-col gap-1">
                <h1 className="text-[#4f4f4f]">Phone Number</h1>
                <div className="flex flex-col md:flex-row items-center divide-y-2 gap-1 divide-gray-700 md:divide-x-2 md:divide-y-0">
                  <a href="tel:+917077560648" className="font-bold text-xl">
                    +91 7077560648
                  </a>
                  <a className="font-bold text-xl" href="tel:+91 7077560638">
                    +91 7077560638
                  </a>
                </div>
              </article>
            </div>
            {/* <div data-aos="fade-up" data-aos-duration="700" className="flex gap-5 items-center">
              <span className="text-[#0BB6D9] text-3xl"><MdOutgoingMail /></span>
              
              <article className="flex flex-col gap-1">
                <h1 className="text-[#4f4f4f]" >Send Us Email</h1>
                <a href="mailto:managingdirector@diagnonextlabs.com" className="font-bold text-xl ">managingdirector@diagnonextlabs.com</a>
              </article>
            </div> */}
            <div
              data-aos="fade-up"
              data-aos-duration="700"
              className="flex gap-5 items-center flex-wrap"
            >
              <span className="text-[#0BB6D9] text-3xl">
                <MdOutgoingMail />
              </span>

              <article className="flex flex-col gap-1">
                <h1 className="text-[#4f4f4f]">Send Us Email</h1>
                <a
                  href="mailto:managingdirector@diagnonextlabs.com"
                  className="font-bold text-xl"
                >
                  managingdirector
                  <br className="block sm:hidden" />
                  @diagnonextlabs.com
                </a>
              </article>
            </div>

            <div
              data-aos="fade-up"
              data-aos-duration="700"
              className="flex gap-5 items-center"
            >
              <span className="text-[#0BB6D9] text-3xl">
                <PiBuildingOfficeDuotone />
              </span>
              <article className="flex flex-col gap-1">
                <h1 className="text-[#4f4f4f]">reach to us</h1>
                <a className="font-bold text-xl">
                  1840/3294/4628, Balianta, Hanspal, Bbsr
                </a>
              </article>
            </div>
          </div>
          <div className="flex flex-col gap-y-5">
            <h4
              data-aos="fade-up"
              data-aos-duration="700"
              className="font-bold text-lg"
            >
              Open Hours
            </h4>
            <div className="flex gap-5 items-center">
              <span
                data-aos="fade-up"
                data-aos-duration="700"
                className="text-[#0BB6D9] text-3xl"
              >
                <CiClock2 />
              </span>
              <article
                data-aos="fade-up"
                data-aos-duration="700"
                className="flex flex-col gap-1"
              >
                <h1 className="text-[#4f4f4f]">Monday - Sunday</h1>
                <p className="font-bold text-xl">6:00am - 9:00pm</p>
              </article>
            </div>
            {/* <div className="flex gap-5 items-center">
              <span
                data-aos="fade-up"
                data-aos-duration="700"
                className="text-[#0BB6D9] text-3xl"
              >
                <CiClock2 />
              </span>
              <article
                data-aos="fade-up"
                data-aos-duration="700"
                className="flex flex-col gap-1"
              >
                <h1 className="text-[#4f4f4f]">Saturday - Sunday</h1>
                <p className="font-bold text-xl">9:00am - 3:30pm</p>
              </article>
            </div> */}
          </div>
        </div>
        <form
          onSubmit={handleSubmit}
          method="post"
          className="xl:w-[50%] bg-white rounded-3xl shadow-lg md:p-8 p-4"
        >
          <HeadingTexts
            label={"About us"}
            text={"Booking for Your"}
            bluetext={"Laboratory Visit"}
          />
          <div className="grid sm:grid-cols-2 grid-cols-1 gap-x-5 mt-5 gap-y-7">
            <div className="flex flex-col gap-y-1">
              <label htmlFor="name">Your Name</label>
              <input
                onChange={handleChange}
                value={formData.firstName}
                placeholder="Your Name"
                className="border border-gray-200 text-gray-600 p-4 focus:outline-[#0BB6D9] transition-all duration-500"
                type="text"
                name="firstName"
                id="name"
              />
            </div>
            <div className="flex flex-col gap-y-1">
              <label htmlFor="email">Email Address</label>
              <input
                onChange={handleChange}
                value={formData.email}
                placeholder="Email Address"
                className="border border-gray-200 text-gray-600 p-4 focus:outline-[#0BB6D9] transition-all duration-500"
                type="email"
                name="email"
                id="email"
              />
            </div>
            <div className="flex flex-col gap-y-1">
              <label htmlFor="phone">Phone Number</label>
              <input
                onChange={handleChange}
                value={formData.phone}
                placeholder="Phone Number"
                className="border border-gray-200 text-gray-600 p-4 focus:outline-[#0BB6D9] transition-all duration-500"
                type="tel"
                name="phone"
                id="phone"
              />
            </div>
            <div className="flex flex-col gap-y-1">
              <label htmlFor="phone">Select Service</label>
              <select
                onChange={handleChange}
                value={formData.speciality}
                name="speciality"
                id="service"
                className="border border-gray-200 text-gray-600 p-4 focus:outline-[#0BB6D9] transition-all duration-500"
              >
                <option value="">Select Service</option>
                <option value="Clinical Biochemistry">
                  Clinical Biochemistry
                </option>
                <option value="Hematology Tests">Hematology Tests</option>
                <option value="Microbiology & Infectious Disease Testing">
                  Microbiology & Infectious Disease Testing
                </option>
                <option value="Histopathology & Cytopathology">
                  Histopathology & Cytopathology
                </option>
                <option value="Molecular & Genetic Testing">
                  Molecular & Genetic Testing
                </option>
              </select>
            </div>
            <div className="flex flex-col gap-y-1 sm:col-span-2">
              <label htmlFor="message">Message</label>
              <textarea
                onChange={handleChange}
                value={formData.query}
                placeholder="Write Your Message"
                name="query"
                id="message"
                className="border border-gray-200 text-gray-600 p-4 focus:outline-[#0BB6D9] transition-all duration-500"
              ></textarea>
            </div>
            <button
              type="submit"
              className="text-white bg-[#0BB6D9] sm:w-fit w-full rounded-md py-4
            px-7 font-semibold hover:bg-black transition-all duration-500 delay-75"
            >
              {loading ? (
                <>
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  Submitting...
                </>
              ) : (
                "Submit Enquiry"
              )}
            </button>
          </div>
          {message && (
            <div
              className={`px-6 pb-6 mt-5 text-center text-sm transition-all duration-300 ${
                message.includes("success") || message.includes("Thank")
                  ? "text-green-600"
                  : "text-red-600"
              }`}
            >
              {message}
            </div>
          )}
        </form>
      </div>
    </section>
  );
};

export default ContactGetInTouch;
